import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '@/layout/service/layout.service';

@Component({
    selector: 'auth-layout',
    standalone: true,
    imports: [RouterModule, AppConfigurator],
    template: `
        <main class="bg-gray-100/50 min-h-screen">
            <router-outlet></router-outlet>
        </main>
        <button class="layout-config-button config-link" (click)="layoutService.toggleConfigSidebar()">
            <i class="pi pi-cog"></i>
        </button>
        <app-configurator location="landing" />
    `
})
export class AuthLayout {
    layoutService: LayoutService = inject(LayoutService);
}
